import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Box } from "@mui/material";
import Chart from 'react-apexcharts';
import image from '../../assets/img/image.png'

function DonutChartFGTracking(props) {
    const toValidNumber = (value) => {
        const num = Number(value);
        return isNaN(num) ? 0 : num;
    };

    const act = toValidNumber(props.act);
    const diff = toValidNumber(props.diff);

    const seriesData = useMemo(() => [act === 0 && diff > 0 ? 0.000001 : act, diff], [act, diff]);

    const total = useMemo(() => seriesData.reduce((acc, val) => acc + val, 0), [seriesData]);

    const options = useMemo(() => ({
        chart: {
            type: 'donut',
            offsetY: 0,
            parentHeightOffset: 0,
            toolbar: { show: false },
            zoom: { enabled: false }
        },
        responsive: [{
            breakpoint: 480,
            options: {
                chart: {
                    width: 100
                },
                legend: {
                    position: 'bottom'
                }
            }
        }],
        plotOptions: {
            pie: {
                expandOnClick: false,
                donut: {
                    size: "80%",
                    labels: {
                        show: false,
                        total: {
                            show: true,
                            label: 'Total',
                            formatter: () => total
                        }
                    }
                }
            }
        },
        stroke: {
            width: 0.5,
            colors: ['#575959']
        },
        colors: ['#0cc694', '#e2e2e2'], // <== เปลี่ยนจาก transparent
        dataLabels: {
            enabled: false,
            formatter: (val, opts) => seriesData[opts.seriesIndex],
        },
        legend: {
            show: false,
        },
        tooltip: {
            enabled: false,
        },
        fill: {
            type: 'solid', // <== ไม่ใช้ gradient แล้ว
        },
    }), [seriesData, total]);

    return (
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'relative', width: '100%', height: '100%' }}>
            <Chart
                options={options}
                series={seriesData}
                type="donut"
                width="100%"
                height="100%"
            />
            <Box sx={{
                position: 'absolute',
                top: { xs: "35%", md: "50%" },
                left: '50%',
                transform: 'translate(-50%, -50%)',
                textAlign: 'center',
                color: '#fff',
                fontFamily: 'CPF_Imm_Sook',
                maxHeight: '40%',
            }}>
                <div style={{ fontSize: 'clamp(12px, 2vw, 16px)', lineHeight: '1' }}><img src={image} alt="person" style={{ height: '6vh', objectFit: 'contain'}} /></div>
                <div style={{ fontSize: 'clamp(28px, 3vw, 48px)', fontWeight: 'bold', lineHeight: '1', margin: '0px 0', color: '#0cc694' }}>{props.persent}%</div>
            </Box>
        </Box>
    );
}

DonutChartFGTracking.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default DonutChartFGTracking;
